import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class BoxOpenModeService {
    public subscriber: Subject<string> = new Subject<string>();
    public mobileControlsOpen: Subject<string> = new Subject<string>();
}